import DataSetShowContainer from './data_set_show_container';

const DataSetShow = DataSetShowContainer;

export default DataSetShow;
